import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { FinanceDashboard } from '../features/finance/FinanceDashboard';

export const Route = createFileRoute('/finance')({
  component: () => (
    <RequireRole allow={['admin']}>
      <FinanceDashboard />
    </RequireRole>
  ),
});
